<template>
  <v-card>
    <v-card-title>入力切替フォーム</v-card-title>
    <v-card-text>
      <v-container>
        <v-row> *必ず先頭に配置する</v-row>
        <v-row>
          <v-col cols="8">
            <v-text-field
              label="ヘッダ名"
              v-model="returnData.label"
              required
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="サイズ"
              v-model="returnData.cols"
              :disabled="returnData.type == 12"
              :rules="[varidation.cols]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="選択肢 カンマ(,)区切り"
              v-model="returnData.value"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-select
              label="追加時のフォームタイプ"
              v-model="returnData.init"
              item-text="label"
              item-value="value"
              :items="items1"
            ></v-select>
          </v-col>
        </v-row>
        <!-------------------------------------->
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    label: String,
    type: Number,
    cols: Number,
    position: Number,
    //個別値
    value: String,
    rule: String,
    init: String,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        type: this.type,
        cols: this.cols,
        position: this.position,
        //個別値
        value: this.value,
        rule: this.rule,
        init: this.init,
      },
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        required: (value) => !!value || "必須項目です",
      },
      //個別値
      rules: [],
      items1: [
        { label: "何も表示しない", value: "" },
        { label: "テキスト入力", value: "inputText" },
        { label: "数値入力", value: "inputNumber" },
      ],
    };
  },
  mounted() {
    if (typeof this.rule != "undefined") {
      this.rules = this.rule.split(",");
    }
  },
  methods: {
    submit() {
      this.returnData.rule = this.rules.join(",");
      //
      this.$emit("clickSubmit", this.returnData);
    },
  },
};
</script>
